import React from 'react';
export function AsSeenOn() {
  return <section className="py-4 bg-white border-b border-gray-100" data-id="element-18">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-19">
        <img src="https://cdn.magicpatterns.com/uploads/scy1on4qBZgKMpV9QkUhyx/PR_As_Seen_Logo_1.png" alt="As Seen On: International Business Times, ABC, Barchart, AP, SI, CBS, NBC and over 450 news sites" className="w-full h-auto object-contain max-h-40" data-id="element-20" />
      </div>
    </section>;
}